export const settingsImageMimeTypes = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/gif',
] as const;

export type SettingsImageMimeType = (typeof settingsImageMimeTypes)[number];

export const SETTINGS_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const SETTINGS_IMAGE_DATA_URL_MAX_LENGTH = Math.ceil(SETTINGS_IMAGE_MAX_BYTES / 3) * 4 + 128;

// Catalog images use the same vetted image formats and request-size budget as company branding.
export const PRODUCT_IMAGE_MAX_BYTES = SETTINGS_IMAGE_MAX_BYTES;
export const PRODUCT_IMAGE_DATA_URL_MAX_LENGTH = SETTINGS_IMAGE_DATA_URL_MAX_LENGTH;
export const PRODUCT_MEDIA_MAX_COUNT = 10;

export const productVideoMimeTypes = ['video/mp4', 'video/webm', 'video/quicktime'] as const;

export type ProductVideoMimeType = (typeof productVideoMimeTypes)[number];

export const PRODUCT_VIDEO_MAX_BYTES = 100 * 1024 * 1024;
export const PRODUCT_VIDEO_DATA_URL_MAX_LENGTH = Math.ceil(PRODUCT_VIDEO_MAX_BYTES / 3) * 4 + 128;

export function isProductVideoMimeType(value: unknown): value is ProductVideoMimeType {
  return typeof value === 'string' && productVideoMimeTypes.includes(value as ProductVideoMimeType);
}

export function isSettingsImageMimeType(value: unknown): value is SettingsImageMimeType {
  return (
    typeof value === 'string' && settingsImageMimeTypes.includes(value as SettingsImageMimeType)
  );
}

export const socialPostVideoMimeTypes = ['video/mp4', 'video/webm', 'video/quicktime'] as const;

export type SocialPostVideoMimeType = (typeof socialPostVideoMimeTypes)[number];

// Social publishing uses JSON data URLs. Keep this within the existing 10 MB request-body default.
export const SOCIAL_POST_VIDEO_MAX_BYTES = 5 * 1024 * 1024;
export const SOCIAL_POST_VIDEO_DATA_URL_MAX_LENGTH =
  Math.ceil(SOCIAL_POST_VIDEO_MAX_BYTES / 3) * 4 + 128;

export function isSocialPostVideoMimeType(value: unknown): value is SocialPostVideoMimeType {
  return (
    typeof value === 'string' && socialPostVideoMimeTypes.includes(value as SocialPostVideoMimeType)
  );
}
